import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login";
import {getDataInLocalStorage} from "@/utils/localStorage";
import Home from "@/views/home/Home";
import Customer from "@/views/systems/Customer/Customer";
import CustomerCompany from "@/views/systems/Customer/CustomerCompany";
import CustomerUser from "@/views/systems/Customer/CustomerUser";
import CustomerGroup from "@/views/systems/Customer/CustomerGroup.vue";
import store from "@/store";
import Test from "@/test/Test";
import Company from "@/views/systems/Company/Company.vue"
import copySalesContract from "@/views/systems/Sales/copySalesContract.vue";
import Log from "@/views/systems/operationlog/Log.vue";
import Info from "@/views/systems/Info.vue";
import Permission from "@/views/systems/Permission/Permission.vue";
import Tickets from "@/views/systems/Tickets/Tickets.vue";
import Check from "@/views/systems/Check/Check.vue";
import ContractAudit from "@/views/systems/Check/ContractAudit.vue";
import TicketsCheck from "@/views/systems/Check/TicketsCheck.vue";
import SysConfig from "@/views/systems/SysConfig/SysConfig.vue";
import Mail from "@/views/systems/Mail/Mail.vue";
import AmountInfo from "@/views/systems/AmountInfo/AmountInfo.vue";
import PaymentInfo from "@/views/systems/AmountInfo/PaymentInfo.vue";
import InvoiceInfo from "@/views/systems/AmountInfo/InvoiceInfo.vue";
import RecordCheck from "@/views/systems/Check/RecordCheck.vue";
import RefundInfo from "@/views/systems/AmountInfo/RefundInfo.vue";
import Impairment from "@/views/systems/Impairment/Impairment.vue";
import Reminder from "@/views/systems/Reminder/Reminder.vue";
import MailInfo from "@/views/systems/AmountInfo/MailInfo.vue";

import Material from "@/views/systems/Material/Material.vue";
import Lexicon from "@/views/systems/Material/Lexicon/Lexicon.vue";
import StockIn from "@/views/systems/Material/StockIn/StockIn.vue";
import Request from "@/views/systems/Material/Request/Request.vue";
import OffSetAudit from "@/views/systems/Check/OffSetAudit.vue";
import RequestMail from "@/views/systems/Material/RequestMail/RequestMail.vue";
import updateLog from "@/views/systems/updateLog.vue";
import PaymentCheck from "@/views/systems/Check/PaymentCheck.vue";
import DryIceArrange from "@/views/systems/Material/DryIceArrange/DryIceArrange.vue";
import Template from "@/views/systems/Template/Template.vue";
import ContractChangeCheck from "@/views/systems/Check/ContractChangeCheck.vue";
import TeamContractAudit from "@/views/systems/Check/TeamContractAudit.vue";
import TerminateApplyAudit from "@/views/systems/Check/TerminateApplyAudit.vue";
import InformationStatistics from "@/views/systems/Customer/InformationStatistics.vue";
import SalesData from "@/views/systems/SalesData/SalesData.vue";
import Email from "@/views/systems/Email/Email.vue";
import TransferContract from "@/views/systems/Contract/TransferContract.vue";
import DeductionRecords from "@/views/systems/Deduction_records/DeductionRecords.vue";
import AdvanceInfo from "@/views/systems/AmountInfo/AdvanceInfo.vue";
import AdvanceCheck from "@/views/systems/Check/AdvanceCheck.vue";
import ReportData from "@/views/systems/ReportData/ReportData.vue";
import { isMobile } from '@/utils';


import LoginM from "@/views/mobile/login/LoginM.vue";
import HomeM from "@/views/mobile/home/HomeM.vue";
import Contract from "@/views/mobile/systems/Sales/Contract.vue";
import InitiateSignContract from "@/views/mobile/systems/sign/InitiateSignContract.vue";
import ShowSignInfo from "@/views/mobile/systems/Sales/ShowSignInfo.vue";
import UserInfo from "@/views/mobile/systems/User/UserInfo.vue";
import Router from "@/views/mobile/systems/Rou/Router.vue";
import SignRecord from "@/views/mobile/systems/SignRecord/SignRecord.vue";

const mobileRoutes = [
    {
        path: '/',
        name: 'home',
        component: HomeM,
        meta: { title: '主页' },
        // 默认重定向到合同页
        redirect: 'Contract',
        children: [
            {
                path: 'Contract',
                name: '合同申请',
                component: Contract,
                meta: {
                    title: '合同申请', requiresAuth: true,
                    permissions: ['ADMIN', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER']
                }
            },
            {
                path: 'routes',
                name: '路由列表',
                component: Router,
                meta: {
                    title: '路由列表', requiresAuth: true,
                    permissions: ['ADMIN', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER']
                }
            },
            {
                path: 'signRecord',
                name: '合同签署记录',
                component: SignRecord,
                meta: {
                    title: '合同签署记录', requiresAuth: true,
                    permissions: ['MANAGER', 'ADMIN', 'SALES_ASSI', 'SALES_MANAGER', 'SALES', 'SALES_ASSI_MANAGER']
                }
            },
            {
                path: 'signContract',
                name: '申请签署',
                component: InitiateSignContract,
                meta: {
                    title: '申请签署', requiresAuth: true,
                    permissions: ['MANAGER', 'ADMIN', 'SALES_ASSI', 'SALES_MANAGER', 'SALES', 'SALES_ASSI_MANAGER']
                }
            },
            {
                path: 'showSignInfo',
                name: '查看签署信息',
                component: ShowSignInfo,
                meta: {
                    title: '查看签署信息', requiresAuth: true,
                    permissions: ['MANAGER', 'ADMIN', 'SALES_ASSI', 'SALES_MANAGER', 'SALES', 'SALES_ASSI_MANAGER']
                }
            },
            {
                path: 'userInfo',
                name: '个人信息',
                component: UserInfo,
                meta: {
                    title: '查看签署信息', requiresAuth: true,
                    permissions: []
                }
            },
        ],
    },
    {
        path: '/login',
        name: 'loginM',
        component: LoginM
    }
]
const pcRoutes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: { title: '主页'},
        children: [{
            path: '/info',
            name: '个人中心',
            component: Info,
            meta: { title: '个人中心'}
        }, {
            path: '/customer',
            name: '客户管理',
            component: Customer,
            meta: { title: '客户管理', requiresAuth: true,
                permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES']},
            children:[
                {
                    path: '/customerCompany',
                    name: '客户单位信息管理',
                    component:CustomerCompany,
                    meta: { title: '客户单位信息管理', requiresAuth: true,
                        permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES']}
                }, {
                    path: '/customerUser',
                    name: '客户联系人信息管理',
                    component:CustomerUser,
                    meta: { title: '客户联系人信息管理', requiresAuth: true,
                        permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES']}
                },{
                    path: '/customerGroup',
                    name: '客户课题组信息管理',
                    component:CustomerGroup,
                    meta: { title: '客户课题组信息管理', requiresAuth: true,
                        permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES']}
                },
            ]
        },{
            path: '/informationStatistics',
            name: '信息统计',
            component:InformationStatistics,
            meta: { title: '信息统计', requiresAuth: true,
                permissions: ['ADMIN','MANAGER','SALES_MANAGER','SALES']}
        }, {
            path: '/salesContract',
            name: '合同申请',
            component: copySalesContract,
            meta: { title: '合同申请', requiresAuth: true,
                permissions: ['ADMIN','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER']}
        },{
            path: '/reportTem',
            name: '报告模板',
            component: ReportData,
            meta: { title: '报告模板', requiresAuth: true,
                permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','TECH']}
            }, {
                path: '/deductionRecords',
                name: '扣除记录',
                component: DeductionRecords,
                meta: {
                    title: '扣除记录', requiresAuth: true,
                    permissions: ['ADMIN', 'BUSINESS_COMMERCIAL', 'MANAGER', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES']
                }
            },
            {
            path: '/tickets',
            name: '发票信息',
            component: Tickets,
            meta: { title: '发票信息', requiresAuth: true,
                permissions: ['ADMIN','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','FINANCE','CASHIER','MANAGER']}
        },{
            path: '/mail',
            name: '邮寄/扫描信息',
            component: Mail,
            meta: { title: '邮寄/扫描信息', requiresAuth: true,
                permissions: ['ADMIN','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER']}
        },{
            path: '/template',
            name: '合同模板',
            component: Template,
            meta: { title: '合同模板', requiresAuth: true,
                permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','TECH']}
        }, {
            path: '/material',
            name: '物料管理',
            component: Material,
            meta: { title: '物料管理', requiresAuth: true,
                permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','LAB','TECH']},
            children: [
                {
                    path: '/lexicon',
                    name: '物料词库',
                    component: Lexicon,
                    meta: { title: '物料词库', requiresAuth: true,
                        permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','LAB','TECH']}
                },{
                    path: '/stockIn',
                    name: '物料入库',
                    component: StockIn,
                    meta: { title: '物料入库', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','SALES_ASSI_MANAGER','SALES_ASSI']}
                },{
                    path: '/request',
                    name: '物料申领',
                    component:Request,
                    meta: { title: '物料申领', requiresAuth: true,
                        permissions: ['ADMIN','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER']}
                },{
                    path: '/requestMail',
                    name: '物料邮寄',
                    component:RequestMail,
                    meta: { title: '物料邮寄', requiresAuth: true,
                        permissions: ['ADMIN','LAB','SALES_ASSI','SALES_ASSI_MANAGER','MANAGER']}
                },{
                    path: '/dryIceArrange',
                    name: '干冰安排',
                    component:DryIceArrange,
                    meta: { title: '干冰安排', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','SALES_ASSI_MANAGER','SALES_ASSI']}
                }
            ]
        },{
            path: '/check',
            name: '商务审批',
            component: Check,
            meta: { title: '商务审批', requiresAuth: true,
                permissions: ['ADMIN', 'MANAGER', 'FINANCE', 'CASHIER', 'BUSINESS_COMMERCIAL', 'ANALYSE', 'AUDITOR', 'SALES_MANAGER', 'SALES']},
            children: [
                {
                    path: '/refundAudit',
                    name: '退票审批',
                    component: TicketsCheck,
                    meta: { title: '退票审批', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','SALES_MANAGER','SALES']}
                },{
                    path: '/contractCheck',
                    name: '合同审批',
                    component: ContractAudit,
                    meta: { title: '合同审批', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','SALES_MANAGER','SALES']}
                },{
                    path: '/contractChange',
                    name: '合同变更审批',
                    component: ContractChangeCheck,
                    meta: { title: '合同变更审批', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','SALES_MANAGER','SALES']}
                },{
                    path: '/teamContractAudit',
                    name: '团队合同审批',
                    component: TeamContractAudit,
                    meta: { title: '团队合同审批', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','SALES_MANAGER','SALES']}
                },{
                    path: '/offSetAudit',
                    name: '正式合同抵扣审批',
                    component: OffSetAudit,
                    meta: {
                        title: '正式合同抵扣审批', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','SALES_MANAGER','SALES']}
                }, {
                    path: '/terminateApply',
                    name: '合同终止审批',
                    component: TerminateApplyAudit,
                    meta: { title: '合同终止审批', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','SALES_MANAGER','SALES']}
                }, {
                    path: '/recordCheck',
                    name: '开票审批',
                    component: RecordCheck,
                    meta: { title: '开票审批', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','BUSINESS_COMMERCIAL','SALES_MANAGER','SALES']}
                },
                {
                    path: '/paymentCheck',
                    name: '项目款认领审批',
                    component: PaymentCheck,
                    meta: { title: '项目款认领审批', requiresAuth: true,
                        permissions: ['ADMIN','FINANCE','CASHIER','MANAGER','SALES_MANAGER','SALES']}
                },
                {
                    path: '/advanceCheck',
                    name: '垫付款认领审批',
                    component: AdvanceCheck,
                    meta: {
                        title: '垫付款认领审批', requiresAuth: true,
                        permissions: ['ADMIN', 'FINANCE', 'CASHIER', 'MANAGER', 'SALES_MANAGER', 'SALES']
                    }
                },
                {
                    path: '/impairment',
                    name: '转预付款',
                    component: Impairment,
                    meta: { title: '转预付款', requiresAuth: true,
                        permissions: ['ADMIN','MANAGER','SALES_MANAGER','SALES']}
                }, {
                    path: '/transferContract',
                    name: '预付款转移',
                    component: TransferContract,
                    meta: {
                        title: '预付款转移', requiresAuth: true,
                        permissions: ['ADMIN', 'MANAGER', 'SALES_MANAGER', 'SALES']
                    }
                },
            ]
        },{
            path: '/amountInfo',
            name: '商务流转',
            component: AmountInfo,
            meta: { title: '商务流转', requiresAuth: true,
                permissions: ['ADMIN','BUSINESS_COMMERCIAL','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','FINANCE','CASHIER','MANAGER']},
            children: [
                {
                    path: '/refundInfo',
                    name: '发票退票',
                    component: RefundInfo,
                    meta: { title: '发票退票', requiresAuth: true,
                        permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER']}
                },{
                    path: '/invoiceInfo',
                    name: '发票开票',
                    component: InvoiceInfo,
                    meta: { title: '发票开票', requiresAuth: true,
                        permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER']}
                },{
                    path: '/mailInfo',
                    name: '资料邮寄/扫描',
                    component: MailInfo,
                    meta: { title: '资料邮寄/扫描', requiresAuth: true,
                        permissions: ['ADMIN','BUSINESS_COMMERCIAL','MANAGER']}
                },{
                    path: '/paymentInfo',
                    name: '到款信息',
                    component: PaymentInfo,
                    meta: { title: '到款信息', requiresAuth: true,
                        permissions: ['ADMIN','FINANCE','CASHIER','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','MANAGER']}
                }, {
                    path: '/advanceInfo',
                    name: '垫付款信息',
                    component: AdvanceInfo,
                    meta: {
                        title: '垫付款信息', requiresAuth: true,
                        permissions: ['ADMIN', 'FINANCE', 'CASHIER', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES', 'MANAGER']
                    }
                },

            ]
        },{
            path: '/log',
            name: '操作日志',
            component: Log,
            meta: { title: '操作日志', requiresAuth: true,
                permissions: ['ADMIN','MANAGER']}
        },{
            path: '/permission',
            name: '权限管理',
            component: Permission,
            meta: { title: '权限管理', requiresAuth: true,
                permissions: ['ADMIN','MANAGER']},
        },{
            path: '/company',
            name: '公司信息',
            component: Company,
            meta: { title: '公司信息', requiresAuth: true,
                permissions: ['ADMIN','MANAGER','BUSINESS_COMMERCIAL','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES','FINANCE','CASHIER']}
        },{
            path: '/salesData',
            name: '销售资料',
            component: SalesData,
            meta: { title: '销售资料', requiresAuth: true,
                permissions: ['ADMIN','SALES_MANAGER','SALES_ASSI','SALES_ASSI_MANAGER','SALES']}
        }, {
                path: '/email',
                name: '邮件管理',
                component: Email,
                meta: {
                    title: '邮件管理', requiresAuth: true,
                    permissions: ['ADMIN', 'SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES']
                }
            },
        {
            path: '/sysConfig',
            name: '系统配置',
            component: SysConfig,
            meta: { title: '系统配置', requiresAuth: true,
                permissions: ['ADMIN']}
        },{
                path: '/reminder',
                name: '日历提醒',
                component: Reminder,
                meta: { title: '日历提醒', requiresAuth: true,
                    permissions: ['ADMIN','BUSINESS_COMMERCIAL']}
        },{
            path: '/updateLog',
            name: '更新日志',
            component: updateLog,
            meta: { title: '更新日志'}
        }
        ],
    },
    {
        path: '/login',
        name: Login,
        component: Login
    },{
        path: '/test',
        name: Test,
        component: Test
    }
]
Vue.use(VueRouter)
const router = new VueRouter({
    routes: isMobile() ? mobileRoutes : pcRoutes,
    base: '/contract',
    mode: 'history',
});
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
// 路由全局前置守卫
router.beforeEach((to, from, next) => {
    // 在路由跳转前执行的逻辑
    const hasToken = getDataInLocalStorage('token')
    const routePermissions = to.meta.permissions
    if (to.path === '/login') {
        next()
    } else {
        if (hasToken) {
            if (to.path !== "/" && to.path !== "/login") { //判断是否要跳到登录界面
                next();
            } else {
                const role = getDataInLocalStorage('role')
                if (isMobile()) {
                    next({
                        path: '/Contract'
                    })
                } else {
                    if (['ADMIN', 'MANAGER'].includes(role)) {
                        next({
                            path: '/contractCheck'
                        })
                    } else if (role === 'BUSINESS_COMMERCIAL') {
                        next({
                            path: '/refundInfo'
                        })
                    } else if (['SALES_MANAGER', 'SALES_ASSI', 'SALES_ASSI_MANAGER', 'SALES','AUDITOR'].includes(role)) {
                        next({
                            path: '/salesContract'
                        })
                    } else if (['FINANCE', 'CASHIER'].includes(role)) {
                        next({
                            path: '/paymentInfo'
                        })
                    } else if (['LAB', 'TECH'].includes(role)) {
                        next({
                            path: '/lexicon'
                        })
                    } else if (['ANALYSE'].includes(role)) {
                        next({
                            path: '/template'
                        })
                    }
                }
                
            }
        } else {
            next('/login')
        }
    }
});
router.afterEach((to, from) => {
    // 在每次路由跳转完成后清空 Vuex 状态
    if(to.path==='/login'){
        store.commit('dataStatus/setInit');
        localStorage.removeItem('viewMode');
        localStorage.removeItem('modeFlag');
    }
    if (to.path === '/login' && !!from.path && from.path !== '/login') {
        store.commit('right/setInit');
    }
});
export default router
